const elementRoles: any = [
  ['menuitem', 'command'],
  ['rel', 'roletype'],
  ['article', 'article'],
  ['header', 'banner'],
  ['input', 'button', [['type', 'checkbox']]],
  ['summary', 'button', [['aria-expanded', 'false']]],
  ['summary', 'button', [['aria-expanded', 'true']]],
  ['input', 'button', [['type', 'button']]],
  ['input', 'button', [['type', 'image']]],
  ['input', 'button', [['type', 'reset']]],
  ['input', 'button', [['type', 'submit']]],
  ['button', 'button'],
  ['td', 'cell'],
  ['input', 'checkbox', [['type', 'checkbox']]],
  ['th', 'columnheader'],
  ['input', 'combobox', [['type', 'email']]],
  ['input', 'combobox', [['type', 'search']]],
  ['input', 'combobox', [['type', 'tel']]],
  ['input', 'combobox', [['type', 'text']]],
  ['input', 'combobox', [['type', 'url']]],
  ['input', 'combobox', [['type', 'url']]],
  ['select', 'combobox'],
  ['select', 'combobox', [['size', 1]]],
  ['aside', 'complementary'],
  ['footer', 'contentinfo'],
  ['dd', 'definition'],
  ['dialog', 'dialog'],
  ['body', 'document'],
  ['figure', 'figure'],
  ['form', 'form'],
  ['form', 'form'],
  ['form', 'form'],
  ['span', 'generic'],
  ['div', 'generic'],
  ['table', 'grid', [['role', 'grid']]],
  ['td', 'gridcell', [['role', 'gridcell']]],
  ['details', 'group'],
  ['fieldset', 'group'],
  ['optgroup', 'group'],
  ['h1', 'heading'],
  ['h2', 'heading'],
  ['h3', 'heading'],
  ['h4', 'heading'],
  ['h5', 'heading'],
  ['h6', 'heading'],
  ['img', 'img'],
  ['img', 'img'],
  ['a', 'link'],
  ['area', 'link'],
  ['link', 'link'],
  ['menu', 'list'],
  ['ol', 'list'],
  ['ul', 'list'],
  ['select', 'listbox'],
  ['select', 'listbox'],
  ['select', 'listbox'],
  ['datalist', 'listbox'],
  ['li', 'listitem'],
  ['main', 'main'],
  ['math', 'math'],
  ['menuitem', 'command'],
  ['nav', 'navigation'],
  ['option', 'option'],
  ['progress', 'progressbar'],
  ['input', 'radio', [['type', 'radio']]],
  ['section', 'region'],
  ['section', 'region'],
  ['frame', 'region'],
  ['tr', 'row'],
  ['tbody', 'rowgroup'],
  ['tfoot', 'rowgroup'],
  ['thead', 'rowgroup'],
  ['th', 'rowheader', [['scope', 'row']]],
  ['input', 'searchbox', [['type', 'search']]],
  ['hr', 'separator'],
  ['input', 'slider', [['type', 'range']]],
  ['input', 'spinbutton', [['type', 'number']]],
  ['output', 'status'],
  ['table', 'table'],
  ['dfn', 'term'],
  ['input', 'textbox'],
  ['input', 'textbox', [['type', 'email']]],
  ['input', 'textbox', [['type', 'tel']]],
  ['input', 'textbox', [['type', 'text']]],
  ['input', 'textbox', [['type', 'url']]],
  ['textarea', 'textbox'],
]

export default elementRoles
